import PropTypes from 'prop-types';
import Modal from '../components/layout/modal.jsx';

import React from 'react';

import authApi from '../../api/auth.jsx';

import articleApi from '../../api/article.jsx';

import {userLevels} from '../helpers/constants.jsx';

import Markdown from 'react-remarkable';

import Loader from '../components/loader.jsx';

import encyclopediaApi from 'api/encyclopedia';

class IntroVideo extends React.Component {
  static propTypes = {
    user: PropTypes.object.isRequired,
    intl: PropTypes.object,
  };

  state = {
    article: null,
    error: false,
  };

  componentWillMount() {
    this.fetchShelfWelcomeMessageData();
  }

  componentDidCatch(error) {
    console.log('Intro video failed to render: ', error);
    this.setState({error: true});
  }

  watchIntroVideo = () => {
    authApi.watchIntroVideo()
      .then(() => {
        window.location.hash = 'customers?tour';
        window.location.reload(false);
      });
  };

  fetchShelfWelcomeMessageData = () => {
    encyclopediaApi.alexPROWelcomePage(this.props.intl.locale).then(article => {
      this.setState({article: {body: article.detailedSection, id: article.id}});
    }).catch(err => {
      console.error(err);
      this.setState({error: true});
    });
  }

  formatArticleBodyWithUsername = (body, userName) => {
    return body.replace(/{username}/g, userName);
  }

  render() {
    let userType = 'Water Testers';

    if (this.props.user.privileges.level >= userLevels.manager) {
      userType = 'Store Managers';
    }
    if (this.props.user.privileges.level >= userLevels.dealerAdmin) {
      userType = 'Dealer Managers';
    }

    if (this.state.error) {
      //ignore introvideo event that failed to render or parse
      return null;
    }

    return (
      <div className='intro-video'>
        <Modal onClose={this.watchIntroVideo}>
          <Loader loaded={!!this.state.article}>
            <Markdown options={{html: true}}>
              {this.state.article && this.formatArticleBodyWithUsername(this.state.article.body, this.props.user.name)}
            </Markdown>
          </Loader>
        </Modal>
      </div>
    );
  }
}

export default IntroVideo;
